export const EXPANDABLE_HELP_VARIANT = {
  MUTED: "muted",
  UNDERLINE: "underline",
} as const;

export type ExpandableHelpVariant = (typeof EXPANDABLE_HELP_VARIANT)[keyof typeof EXPANDABLE_HELP_VARIANT];
